import React from 'react';

import SessionService from '../../../services/session.service';
import { API_HOST } from '../../../constants/server.constant';
import { axiosRequestWithAuth, axiosInstance } from './../../../constants/server.constant';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import $ from 'jquery';

export default class NotificationSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            regionCount: 0,
            regionList: [],
            regionString: ""
        };
    }

    componentDidMount() {
        this.getMaintananceRegions();
    }

    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth).
            then(resp => {
                if(resp?.data) {
                    let res = resp.data;

                    this.setState({
                        regionCount: res.length,
                        regionList: res
                    });
                    let string = "";
                    if(res.length > 0) {
                        for(let i = 0; i < res.length; i++) {
                            string += res[i].name + " (" + res[i].region_id + ")" + ", ";
                        }
                        this.setState({
                            isRegionStatus: true,
                            regionString: string.replace(/,\s*$/, "")
                        });
                    }
                }

            })
            .catch(error => {
                console.log(error);
            });
    };

    closeSlider = () => {
        $(".cluster_slider").removeClass("active");
        $("body").removeClass("popup_no_scroll");
    };

    render() {
        return (
            <div>
                <div className="main_slider cluster_slider">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.closeSlider() }></div>
                            <div className="cluster_slider_wrap">
                                <div className="head_block">
                                    <h2>Notifications</h2>
                                </div>
                                <div className="cluster_content_wrap">
                                    { this.state.regionCount == 1 ?
                                        <div className="cluster_blk" >
                                            <p><b>Region { this.state.regionString } is under maintenance. </b></p>
                                            <p>You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period.</p>
                                            <p>We are trying to resolve this at the earliest. Thank you for your patience.</p>

                                            <a href="https://status.idrivecompute.com" target="_blank" ><input type="button" name="" className="common_cta_btn blue" value="Check Status" /></a>
                                        </div>
                                        :
                                        <div className="cluster_blk">
                                            <p><b>Regions { this.state.regionString } are under maintenance. </b></p>
                                            <p>You will not be able to create resources e.g. instances, volumes, etc., in this region and the existing resources may also become inaccessible during this period.</p>
                                            <p>We are trying to resolve this at the earliest. Thank you for your patience.</p>

                                            <a href="https://status.idrivecompute.com" target="_blank" ><input type="button" name="" className="common_cta_btn blue" value="Check Status" /></a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

